import { ISuggestionV2Schema } from '../repositories/text-search/entities/suggestions_query_string/SuggestionV2Schema';
import { ISuggestion } from '../types/suggestions';

export const prepareSuggestions = (suggestions: ISuggestionV2Schema[]): ISuggestion[] => {
  return suggestions.map(({ text, queryString, type, isUserSuggest, isDefault, geo, icon }) => ({
    query: text,
    icon,
    url: `/cat.php?${queryString}`,
    type,
    geo,
    isUserSuggest: !!isUserSuggest,
    isDefault,
  }));
};
